//
// Shows the topic or content select in the task view grant access form for the chosen radio button.
//
window.addEventListener('DOMContentLoaded', () => {

	const form = document.querySelector('[data-grant-access]');
	if (!form) {
		return;
	}

	const radioList = form.querySelectorAll('[data-grant-access-radio]');
	const targetList = form.querySelectorAll('[data-grant-access-target]');

	//
	// Shows the select that belongs to the checked radio and disables the others so they are not submitted or validated.
	//
	const update = () => {

		const checked = form.querySelector('[data-grant-access-radio]:checked');

		targetList.forEach((target) => {
			const visible = checked !== null && target.dataset.grantAccessTarget === checked.value;
			target.classList.toggle('d-none', !visible);
			target.querySelector('select').disabled = !visible;
		});
	};

	radioList.forEach((radio) => {
		radio.addEventListener('change', update);
	});

	update();
});
